export interface LocationDescription {
  name: string;
  description: string;
  atmosphere: string;
  features: string[];
  dangers: string[];
}

export const LOCATION_DATA: Record<string, LocationDescription> = {
  'The Red Market': {
    name: 'The Red Market',
    description: 'A bustling marketplace where merchants from across Dark Hells gather to trade exotic goods, rare artifacts, and forbidden knowledge.',
    atmosphere: 'Chaotic and vibrant. The smell of spices, leather, and old magic fills the air. Voices echo between stalls covered in crimson cloth.',
    features: [
      'Ebonveil Magician Shop',
      'Ancient artifact stalls',
      'Black market dealers',
      'Alchemist vendors',
      'Information brokers',
    ],
    dangers: ['Pickpockets', 'Scams', 'Rival merchants', 'Corrupt guards'],
  },
  'The Lazerate': {
    name: 'The Lazerate',
    description: 'Home to the prestigious Nocturne & Thorn Mage College, this ancient tower is shrouded in perpetual twilight and arcane energy.',
    atmosphere: 'Mysterious and academic. Ancient tomes float through the halls, and the air crackles with magical potential.',
    features: [
      'Nocturne & Thorn Mage College',
      'Arcane library',
      'Ritual chambers',
      'Apprentice quarters',
      'Tower observatory',
    ],
    dangers: ['Wild magic', 'Mage duels', 'Cursed artifacts', 'Temporal anomalies'],
  },
  'Vestuvia': {
    name: 'Vestuvia',
    description: 'A grand city ruled by the Countess Nadia. Two academies—Ashen Crown and NightSpire—train warriors and knights respectively.',
    atmosphere: 'Regal and structured. The sound of training steel, royal banners, and organized military might.',
    features: [
      'Ashen Crown Royal Academy',
      'NightSpire Knight Academy',
      "Countess Nadia's Palace",
      'Grand training grounds',
      'Noble districts',
    ],
    dangers: ['Political intrigue', 'Military enforcers', 'Assassination attempts', 'Class warfare'],
  },
  'The Oasis': {
    name: 'The Oasis',
    description: 'A serene sanctuary hidden within barren desert lands. Crystal-clear waters flow from a mysterious underground spring.',
    atmosphere: 'Peaceful and otherworldly. Desert winds carry whispers of ancient civilizations.',
    features: [
      'Crystal springs',
      'Ancient ruins',
      'Desert nomad camps',
      'Hidden grottos',
      'Stargazing cliffs',
    ],
    dangers: ['Sand storms', 'Desert creatures', 'Bandits', 'Mirages'],
  },
  'The Single Cell Biom': {
    name: 'The Single Cell Biom',
    description: 'A vast organic landscape where massive cellular structures form living ecosystems. Reality bends strangely here.',
    atmosphere: 'Surreal and unsettling. The environment pulses with life force.',
    features: [
      'Living cell clusters',
      'Bio-luminescent flora',
      'Mutation pools',
      'Organic caverns',
      'Evolution gardens',
    ],
    dangers: ['Mutations', 'Parasitic lifeforms', 'Cellular decay', 'Reality distortions'],
  },
  'The Badlands': {
    name: 'The Badlands',
    description: 'A harsh, desolate region of cracked earth and violent storms. Home to outcasts, exiles, and dangerous creatures.',
    atmosphere: 'Grim and violent. The wind howls with an air of desperation and danger.',
    features: [
      'Outcast settlements',
      'Ravine networks',
      'Storm weather',
      'Ancient bones',
      'Hidden caves',
    ],
    dangers: ['Extreme weather', 'Bandits', 'Feral beasts', 'Quicksand'],
  },
  'The Mushroom Caves': {
    name: 'The Mushroom Caves',
    description: 'Vast underground caverns filled with bioluminescent fungi of impossible sizes. A realm of fungal secrets.',
    atmosphere: 'Dark and eerie. Soft glowing lights cast strange shadows on peculiar fungal formations.',
    features: [
      'Giant mushroom forests',
      'Spore clouds',
      'Underground lakes',
      'Fungal gardens',
      'Mycelial networks',
    ],
    dangers: ['Toxic spores', 'Fungal creatures', 'Cave collapse', 'Mind-altering fungi'],
  },
  'The Bioluminescent Caves': {
    name: 'The Bioluminescent Caves',
    description: 'Stunning caverns where every surface glows with natural light. Beauty and danger intertwine here.',
    atmosphere: 'Magical and beautiful. Ethereal light dances across crystalline walls.',
    features: [
      'Glowing crystals',
      'Light-dependent creatures',
      'Luminous pools',
      'Radiant formations',
      'Echo chambers',
    ],
    dangers: ['Light sensitivity creatures', 'Crystal traps', 'Unstable geology', 'Blindness hazards'],
  },
  'The Split Mountains': {
    name: 'The Split Mountains',
    description: 'Towering peaks torn asunder by ancient cataclysm. A place where sky and earth seem to collide.',
    atmosphere: 'Grand and perilous. Winds howl through massive chasms, and peaks touch the clouds.',
    features: [
      'Massive chasms',
      'Sky temples',
      'Mountain sanctuaries',
      'Floating islands',
      'Eagle nests',
    ],
    dangers: ['Avalanches', 'High altitude sickness', 'Extreme cold', 'Lightning storms'],
  },
  'The Ecological Dead Zone': {
    name: 'The Ecological Dead Zone',
    description: 'A wasteland where nature itself has died. The air is heavy, and silence is deafening.',
    atmosphere: 'Oppressive and hopeless. The absence of life creates an overwhelming emptiness.',
    features: [
      'Barren wastelands',
      'Ruins of old civilization',
      'Dead forests',
      'Poison marshes',
      'Void echoes',
    ],
    dangers: ['Radiation', 'Undead creatures', 'Environmental poison', 'Psychological torment'],
  },
};
